import {
  ChangeEmailAddressPayload,
  DeleteAccountPayload,
  ChangeEmailStartPayload,
  ChangeEmailVerifyPayload,
  I18nAccountError,
  Mutation as accountMutations,
} from './account/account-resolver-overrides';
import {
  UnsubscribeApacSavedSearchByCodePayload,
  UpdateNotificationCtpPreferencesPayload,
  UpdateNotificationCtpSubscriptionWithTokenPayload,
  Mutation as notificationsMutations,
  Candidate as notificationCandidates,
} from './notifications/notifications-resolver-overrides';
import {
  UpdateShareableProfileSettingsPayload,
  Mutation as visibilityMutations,
} from './visibility/visibility-resolver-overrides';

const resolverOverrides = (_mockStore: any) => ({
  // Account:
  ChangeEmailAddressPayload,
  I18nAccountError,
  DeleteAccountPayload,
  ChangeEmailStartPayload,
  ChangeEmailVerifyPayload,

  // Visibility:
  UpdateShareableProfileSettingsPayload,

  // Notifications:
  UnsubscribeApacSavedSearchByCodePayload,
  UpdateNotificationCtpPreferencesPayload,
  UpdateNotificationCtpSubscriptionWithTokenPayload,

  Mutation: {
    ...accountMutations,
    ...visibilityMutations,
    ...notificationsMutations,
  },

  Candidate: {
    ...notificationCandidates,
  },
});

export default resolverOverrides;
